// Presentation boundary, not authentication. Server draft ownership stays authoritative.
let scope = 'guest';
let revision = 0;
export function setDraftAccount(user, ready = true) {
  const id = Number(user?.id);
  const next = !ready ? 'pending' : user ?
    (Number.isSafeInteger(id) && id > 0 && user.role ? `account:${id}:${user.role}` : 'pending') : 'guest';
  if (next !== scope) { scope = next; revision += 1; }
  return scope;
}
export function draftAccountSnapshot() { return { scope, revision }; }
export function draftAccountIsCurrent(snapshot) {
  return snapshot.scope !== 'pending' && snapshot.scope === scope && snapshot.revision === revision;
}
